import { render, staticRenderFns } from "./DocumentTypeUpdateForm.vue?vue&type=template&id=4cd0b74e"
import script from "./DocumentTypeUpdateForm.vue?vue&type=script&lang=js"
export * from "./DocumentTypeUpdateForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports